export default "__VITE_ASSET__5Hok8cBT__"